import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./LoginForm.css";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";

const ResetPasswordSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showemail, setShowEmail] = useState("");

  useEffect(() => {
    // Parse the query parameters from the URL
    const searchParams = new URLSearchParams(location.search);
    const email = searchParams.get("email");
    setShowEmail(email);
    // Do something with the email, e.g., update state
    // setEmail(email);
  }, [location.search]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message =
        "The page that you're looking for used information that you entered. Returning to that page might cause any action that you took to be repeated. Do you want to continue?";
      event.returnValue = message; // Standard for most browsers
      return message; // For some older browsers
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    navigate("/scancam-edge/forgotpassword");
  };
  return (
    // <div className="page-container showNormalFont">
    //     <form className="content-container" onSubmit={handleSubmit}>
    //         <div className="login-header w-100">
    //             <div className="circle-icon">
    //                 <MailOutlineOutlinedIcon style={{ fontSize: '2.5rem' }} />
    //             </div>
    //             <div className="forgotPassword-form-title">
    //                 <h1>Check Your Email</h1>
    //             </div>
    //             <h2 className="forgotPassword-form-subtitle text-center pt-0">
    //                 Please check the email address {showemail} for instructions to reset your password
    //             </h2>
    //         </div>
    //         <div className="login-body w-100">
    //             <button className="resetpasswordsuccess-continueButton" type="submit">
    //                 Resend email
    //             </button>
    //             <Link to="/scancam-edge/" className="mt-4 back-button">
    //                 Go Back
    //             </Link>
    //         </div>
    //     </form>
    // </div>
    <div className="login-container">
      <div className="login-box">
        <form method="post" onSubmit={handleSubmit} className="login-form">
          <div className="login-form-container">
            <div className="login-header-forgot-Password-success">
              <div className="circle-icon">
                <MailOutlineOutlinedIcon style={{ fontSize: "2.5rem" }} />
              </div>
              <h1 className="welcome-heading">Check Your Email</h1>
              <p className="welcome-text">
                Please check the email address {showemail} for instructions to
                reset your password
              </p>
            </div>
            <div className="login-input-container">
              <div className="login-input-wrapper"></div>
            </div>
            <div className="login-actions">
              <button type="submit" className="resend-button">
                Resend Email
              </button>
              <Link className="back-button" to={"/scancam-edge"}>
                Go Back
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordSuccess;
